import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { appStore } from "../../../../Store/appStore";
import { IRecycleTechnologyDictionary, ITorchCH4Dictionary } from "../../../../StoreCollections/dictionaryStore";
import Loading from "../../../Loading/Loading";
import { regex } from "./RegExpr";
import { InlineMath } from "react-katex";

interface RecycleTechnologyProps {
  mode: string;
  selectedCalculation: any;
  onMethanChange: (value: number) => void;
  onAMethanChange: (value: number ) => void;
}

const RecycleTechnologyCalculation: React.FC<RecycleTechnologyProps> = ({
  mode,
  selectedCalculation,
  onMethanChange,
  onAMethanChange
}) => {

  const fixedValue = parseInt(localStorage.getItem("comma")!);

  const [methan, setMethan] = useState("");

  const [amethan, setAMethan] = useState("");

  useEffect(() => {
    onMethanChange(Number(methan));
    }, [methan]);

  useEffect(() => {
    onAMethanChange(Number(amethan));
    }, [amethan]);

  useEffect(() => {
    if (mode === "edit") {
      if (selectedCalculation) {
        
      }
    }
  }, [selectedCalculation]);


  return (
    <>
      <Form.Label>
        Концентрация метана в метановоздушной смеси, %
      </Form.Label>
      <Form.Control
              value={methan}
              onChange={(e) => {
                if (regex(mode).test(e.target.value)) {
                  setMethan(e.target.value);
                }
              }}
              type="text"
            />
      <Form.Label>
      Абсолютная метанообильность, 
        <InlineMath math="м^{3}" />/мин
      </Form.Label>
      <Form.Control
              value={amethan}
              onChange={(e) => {
                if (regex(mode).test(e.target.value)) {
                  setAMethan(e.target.value);
                }
              }}
              type="text"
            />
      </>
  );
};

export default observer(RecycleTechnologyCalculation);
